import { genericFieldValidation } from '../../utils/form-validation/form-validation';

export const getFormDataErrors = ({ inquiry }) => {
  return {
    inquiry: genericFieldValidation(inquiry),
  };
};

export const getOnLoginFailureErrors = ({ response }) => {
  const newErrors = {
    inquiry: null
  };

  if (!response || !response.data || !response.data.error) {
    return newErrors;
  }

  const { error } = response.data;

  if (error.inquiry) {
    newErrors.inquiry = error.inquiry;
  }

  return newErrors;
};
